"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ClinicianAppointmentStatistics = _interopRequireDefault(require("./ClinicianAppointmentStatistics"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _ClinicianAppointmentStatistics.default;
exports.default = _default;